import { z } from 'zod';

/**
 * `GET /matrices/:id/composed-prompt` — role-gated server-side (pms only,
 * see docs/design/matrice-creation-wizard/2026-08-04-matrice-creation-wizard-design.md
 * decision 16). Composed fresh every time: the runner prompt with its
 * variables filled, then setup + person context + sujet/contexte/dimensions
 * (issue #17). The documents and the JSON output instructions are not part of
 * it — generation always appends them. Never itself persisted.
 */
export const composedPromptSchema = z.object({
  prompt: z.string(),
});
export type ComposedPrompt = z.infer<typeof composedPromptSchema>;
